import * as Immutable from 'immutable';
import DineroFactory, { Currency } from 'dinero.js';
import { SignupStatus, PasswordStatus, CartStatus } from '../_actions/UIDataActions';
import UIToastStore, { IToast } from './UIToastStore';
import UIOrderingStore, { IUIOrdering } from './UIOrderingStore';
import { Fabric } from '../_data/Fabrics';

interface IProvince {
	id: number
	name: string
	alpha2_code: string
}

const defaultProvince = Immutable.Record<IProvince>({
	id: null,
	name: '',
	alpha2_code: '',
});

export class Province extends defaultProvince implements IProvince {};

interface ICountry {
	id: number
	name: string
	alpha2_code: string
	alpha3_code: string
	provinces: Immutable.OrderedMap<number, Province>
}

const defaultCountry = Immutable.Record<ICountry>({
	id: null,
	name: '',
	alpha2_code: '',
	alpha3_code: '',
	provinces: Immutable.OrderedMap<number, Province>(),
});

export class Country extends defaultCountry implements ICountry {}

interface IPrice {
	amount: number
	currency: Currency
}

const defaultPrice = Immutable.Record<IPrice>({
	amount: 0,
	currency: 'USD'
});

export class Price extends defaultPrice implements IPrice {
	constructor(params?:IPrice) {
		if(params) {
			super({
				amount: Number(params.amount),
				currency: String(params.currency) as Currency
			});
		} else super();
	}

	public toDinero():Dinero.Dinero {
		return DineroFactory({
			amount: this.get('amount'),
			currency: this.get('currency'),
		});
	}
}

export interface IUIDataStore {
	toast: IToast,
	ordering: IUIOrdering,
	countries: Immutable.OrderedMap<number, Country>
	fabrics: Immutable.OrderedMap<number, Fabric>
	loaders: Immutable.Map<string, boolean>,
	signupStatus: SignupStatus,
	passwordStatus: PasswordStatus,
	cartStatus: CartStatus,
}

const defaultStore = Immutable.Record<IUIDataStore>({
	toast: new UIToastStore(),
	ordering: new UIOrderingStore(),
	countries: Immutable.OrderedMap(),
	fabrics: Immutable.OrderedMap(),
	loaders: Immutable.Map<string, boolean>(),
	signupStatus: "signup",
	passwordStatus: "forgot",
	cartStatus: "cart",
});

export default class UIDataStore extends defaultStore implements IUIDataStore {}